export default __webpack_public_path__ + "static/media/expand-all-outline.bad61fbb.svg";